// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// сервер сменил константу с byte = -1; на byte = -2
export var InstrumentTradingBalance;
(function (InstrumentTradingBalance) {
    InstrumentTradingBalance[InstrumentTradingBalance["SETTLEMENT_IMMEDIATE"] = 254] = "SETTLEMENT_IMMEDIATE";
    InstrumentTradingBalance[InstrumentTradingBalance["SETTLEMENT_T_PLUS"] = 255] = "SETTLEMENT_T_PLUS"; // T+0 (today)
})(InstrumentTradingBalance || (InstrumentTradingBalance = {}));
